export default "__VITE_ASSET__d5bc6dc5__"